// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__k4Eu6","consentsList":"PatientConsents_consentsList__Mhgqn","consentsListEmpty":"PatientConsents_consentsListEmpty__3JDMK"};